import React from 'react';
import { Link } from 'react-router-dom';

const MarathonSection = () => {
  return (
    <div className='bg-slate-100 py-4'>
      <div className='max-w-[980px] mx-auto px-4'>
        <div className='rounded-[32px] bg-white border border-slate-200 shadow-sm p-5 mb-4'>
          <div className='text-center max-w-3xl mx-auto'>
            <p className='text-slate-500 uppercase tracking-[0.24em] font-semibold text-[10px] mb-4'>Green Runners • Green Nation</p>
            <h1 className='text-slate-900 text-[2rem] md:text-[2.5rem] font-extrabold tracking-tight leading-[1.03] mb-3'>Kalingarayan Pasumai Marathon 2026</h1>
            <p className='text-slate-600 text-sm sm:text-base leading-7'>Join us for the Kalingarayan Pasumai Marathon 2026, a celebration of fitness, community, and environmental awareness. Set amidst the scenic surroundings of Bhavani, this event brings together runners of all ages and abilities to promote healthy living and a greener future.</p>
          </div>
        </div>

        <div className='grid gap-4'>
          <div className='grid gap-3 md:grid-cols-3'>
            <div className='rounded-[28px] bg-white border border-slate-200 p-4 shadow-sm'>
              <p className='text-slate-500 uppercase tracking-[0.16em] text-[10px] mb-2'>Date</p>
              <p className='text-slate-900 font-semibold'>16 Aug 2026</p>
            </div>
            <div className='rounded-[28px] bg-white border border-slate-200 p-4 shadow-sm'>
              <p className='text-slate-500 uppercase tracking-[0.16em] text-[10px] mb-2'>Time</p>
              <p className='text-slate-900 font-semibold'>5:00 AM – 8:00 AM</p>
            </div>
            <div className='rounded-[28px] bg-white border border-slate-200 p-4 shadow-sm'>
              <p className='text-slate-500 uppercase tracking-[0.16em] text-[10px] mb-2'>Venue</p>
              <p className='text-slate-900 font-semibold'>Paviesh Park, Bhavani</p>
            </div>
          </div>

          <div className='grid gap-4 lg:grid-cols-[0.95fr_1.05fr]'>
            <div className='rounded-[32px] bg-white border border-slate-200 p-5 shadow-sm'>
              <h2 className='text-slate-900 text-lg font-semibold mb-4'>Age Categories</h2>
              <div className='grid gap-3'>
                <div className='rounded-full border border-slate-200 bg-slate-50 py-4 px-4 text-center text-slate-900 font-semibold shadow-sm'>12–18 Years</div>
                <div className='rounded-full border border-slate-200 bg-slate-50 py-4 px-4 text-center text-slate-900 font-semibold shadow-sm'>19 -37 Years</div>
                <div className='rounded-full border border-slate-200 bg-slate-50 py-4 px-4 text-center text-slate-900 font-semibold shadow-sm'>38 -54 Years</div>
                <div className='rounded-full border border-slate-200 bg-slate-50 py-4 px-4 text-center text-slate-900 font-semibold shadow-sm'>55+ Years</div>
              </div>
            </div>

            <div className='rounded-[32px] bg-white border border-slate-200 p-5 shadow-sm'>
              <h2 className='text-slate-900 text-lg font-semibold mb-4'>Registration Benefits</h2>
              <div className='space-y-5 text-slate-700'>
                <div>
                  <p className='font-semibold text-slate-900 mb-2'>10 KM Timed Run & 5 KM Timed Run</p>
                  <ul className='list-disc list-inside space-y-2 text-sm leading-6'>
                    <li>Official Event T-Shirt</li>
                    <li>Finisher Medal</li>
                    <li>Bib Number with Timing Chip</li>
                    <li>Electronic Race Timing Results</li>
                    <li>Breakfast</li>
                  </ul>
                </div>
                <div>
                  <p className='font-semibold text-slate-900 mb-2'>5 KM Jolly Run</p>
                  <ul className='list-disc list-inside space-y-2 text-sm leading-6'>
                    <li>Official Event T-Shirt</li>
                    <li>Finisher Medal</li>
                    <li>Breakfast</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className='rounded-[32px] bg-white border border-slate-200 p-5 shadow-sm'>
            <h3 className='text-slate-900 text-lg font-semibold mb-3'>Event Categories</h3>
            <div className='grid gap-3 md:grid-cols-3'>
              <div className='rounded-[24px] bg-slate-50 border border-slate-200 p-4'>
                <p className='font-semibold text-slate-900'>10 KM Timed Run</p>
                <span className='inline-flex items-center rounded-full bg-slate-900 px-3 py-1 text-white text-[11px] font-semibold'>₹700</span>
              </div>
              <div className='rounded-[24px] bg-slate-50 border border-slate-200 p-4'>
                <p className='font-semibold text-slate-900'>5 KM Timed Run</p>
                <span className='inline-flex items-center rounded-full bg-slate-900 px-3 py-1 text-white text-[11px] font-semibold'>₹600</span>
              </div>
              <div className='rounded-[24px] bg-slate-50 border border-slate-200 p-4'>
                <p className='font-semibold text-slate-900'>5 KM Jolly Run</p>
                <span className='inline-flex items-center rounded-full bg-slate-900 px-3 py-1 text-white text-[11px] font-semibold'>₹500</span>
              </div>
            </div>
          </div>

          <div className='rounded-[32px] bg-white border border-slate-200 p-5 shadow-sm text-slate-700'>
            <p className='font-semibold text-slate-900 mb-3'>Note</p>
            <p className='leading-7 mb-4'>The 5 KM Jolly Run is a non-competitive fun run. No timing chip, race timing, certificate, rankings, or podium positions will be provided for Jolly Run participants.</p>
            <div>
              <p className='font-semibold text-slate-900 mb-3'>Race Timing Information</p>
              <ul className='list-disc list-inside space-y-2 text-sm leading-6'>
                <li>Timing chips are provided only for the 10 KM and 5 KM Timed Run categories.</li>
                <li>The chip is attached to the race bib and official timing is recorded from start to finish.</li>
                <li>Participants must wear their bib visibly during the race.</li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
            <Link to='/registration' className='block w-full sm:w-auto'>
              <button className='w-full sm:w-auto bg-slate-900 hover:bg-slate-800 text-white font-semibold py-3 px-8 rounded-3xl transition duration-300 shadow-lg'>🚀 Register Now</button>
            </Link>
            <div className='rounded-[28px] bg-white border border-slate-200 p-4 shadow-sm text-center text-slate-700'>
              <p className='font-semibold text-slate-900 mb-1'>Contact Information</p>
              <p>98427 30160 • 99442 280160</p>
            </div>
          </div>

          <div className='rounded-[32px] bg-white border border-slate-200 p-4 shadow-sm text-center'>
            <p className='text-slate-900 font-semibold text-base'>Run for Fitness. Run for Nature. Run for a Greener Tomorrow.</p>
            <p className='text-slate-600 text-sm mt-2'>Don’t just watch the run—be part of it. We look forward to seeing you at the starting line!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarathonSection;
